<script>
import rostex from '@img/partners/rostex.png'
import serverstal from '@img/partners/serverstal.png'
import vodokanal from '@img/partners/vodokanal.png'
import vnukovo from '@img/partners/vnukovo.png'
import x5 from '@img/partners/x5.png'
import renessans from '@img/partners/renessans.png'
import pik from '@img/partners/pik.png'
import metalservice from '@img/partners/metalservice.png'
import dsk from '@img/partners/dsk.png'

export default {
    name: "HomeAboutBlock",
    data() {
        return {
            logos: [
                { src: rostex, alt: "Ростех" },
                { src: serverstal, alt: "Северсталь" },
                { src: vodokanal, alt: "Мосводоканал" },
                { src: vnukovo, alt: "Внуково" },
                { src: x5, alt: "X5 Retail Group" },
                { src: renessans, alt: "Renaissance Construction" },
                { src: pik, alt: "ПИК" },
                { src: metalservice, alt: "Металл Сервис" },
                { src: dsk, alt: "ДСК" },
            ],
        };
    },
};
</script>

<template>
    <div class="w-full bg-grayBg rounded-3xl text-black overflow-hidden">
        <div class="grid grid-cols-1 md:grid-cols-2 h-full md:min-h-[325px] md:divide-x">
            <div class="flex-1 flex flex-col order-2 md:order-1 p-5 md:p-10">
                <h1 class="mb-[30px] text-2xl font-bold">
                    ВторЧерМет-1 — профессиональный приём и переработка металлолома.
                </h1>

                <div class="flex flex-col gap-2 text-sm">
                    <p>
                        Компания ВторЧерМет-1 осуществляет приём черного и цветного металлолома
                        от частных лиц и предприятий. Принимаем сталь, чугун, медь, алюминий,
                        латунь, кабель, аккумуляторы и другие виды металла.
                    </p>
                    <p>
                        Работаем по актуальным рыночным ценам с прозрачным расчётом веса.
                        Используем поверенные весы и гарантируем честное взвешивание.
                        Возможен наличный и безналичный расчёт.
                    </p>
                    <p>
                        Организуем вывоз металлолома собственным транспортом,
                        обеспечиваем погрузку и оперативное оформление документов.
                        Работаем официально и предоставляем полный пакет документов
                        для юридических лиц.
                    </p>
                </div>
            </div>

            <div class="order-1 md:order-2">
                <div class="w-full h-full grid grid-cols-3 divide-x divide-y">
                    <div
                        v-for="(logo, index) in logos"
                        :key="index"
                        class="flex items-center justify-center p-6 transition hover:bg-gray-200"
                    >
                        <img
                            :src="logo.src"
                            :alt="logo.alt"
                            class="max-h-[60px] w-auto object-contain opacity-60 hover:opacity-100 transition"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
img {
    filter: invert(50%);
}
</style>
